export enum EditableFieldsTranslation {
  Action = 'editable-fields-action',
  Status = 'editable-fields-status',
  Update = 'editable-fields-update',
}
